<template>
    <div class="grade-list">
        <div class="top">
            <a href="javascript:history.go(-1);" class="back" v-if="isUa">
                <i class="el-icon-arrow-left"></i>
            </a>
            {{name}}
            <!--<a href="" class="right">
                保存
            </a>-->
        </div>
        <ul v-if="list.length > 0">
            <li v-for="(item,index) in list" @click="save(item.id)" :key="index">
                {{item.name}} <span v-if="item.id==currentgarde">已选</span>
            </li>
        </ul>
        
        <Loading :show="isUa && isLoading"></Loading>    
    </div>
</template>

<script>
import jsonp from 'jsonp'
import cookie from 'cookie'
import Loading from '../loading'

export default{
    name: 'SelectGrade',
    data(){
        return{
            sortid: this.$route.params.sortid,
            name: "选择年级",
            isUa: window.navigator.userAgent.indexOf('ZgApp') < 0,
            isLoading: false,
            isData: false,
            isNoData: false,
            currentgarde:this.getCookie("grade")||7,
            list: []    
        }    
    },
    mounted(){
        this.getGradeList();  
        this.getStatistPv();  
    },
    methods:{
        save(id){
            //alert(id);
            this.createCookie("grade",id,30);
            history.go(-1);
        },
        getGradeList(){
            this.isLoading = true;
            //测试数据
            //this.list = [{id:7,name:"初一"},{id:8,name:"初二"}];
            //this.isLoading = false;
            jsonp(`http://byte.gxnews.com.cn/php/qdapi.php?action=grades`, {} , (err, data) => {
                this.isLoading = false;
                console.log("grade list",data);
                this.list = data.data;
            })
        },
        createCookie(key,value,expires){
            var cookieText = encodeURIComponent(key) + '=' + encodeURIComponent(value) + ';path=/';
            if(!isNaN(expires)){
                var date = new Date();
                date.setDate(date.getDate() + expires);
                cookieText += ';expires=' + date;
            }
            document.cookie = cookieText;
        },
        getCookie(key){
            var arr = document.cookie.split('; ');
            for(var i = 0,len = arr.length;i < len;i ++){
                var list = arr[i].split('=');
                if(encodeURIComponent(key) === list[0]){
                    return decodeURIComponent(list[1]);
                }
            }
        },
        getStatistPv(){
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=http%3a%2f%2fbyte.gxnews.com.cn%2fzg%2f%23%2fselectgrade&tag=zgapp&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            })   
        }
    },
    components:{
        Loading
    },
}
</script>

<style lang="less" scoped>
    .grade-list{
        padding: 1.3rem 0 1.6rem 0;
        h2{
            font-size: 0.45rem;
            color: #333;
            font-weight: bold;
            margin-bottom: 0.2rem;
            padding: 0 0.3rem;
            span{
                display: inline-block;
                height: 0.6rem;
                width: 0.15rem;
                background: #3793f4;
                vertical-align: middle;
                margin-right: 0.25rem;
                border-radius: 0.2rem;
            }
        }
        li{
            padding: 0 0.3rem 0.25rem 0.3rem;
            border-bottom: 1px solid #ececec;
            margin-bottom: 0.3rem;
            font-size: 0.5rem;
            &:nth-last-of-type(1){
                border-bottom: none;
                margin-bottom: 0;
            }
            a{
                display: block;
            }
            span{
                color:green;
                right: 0.5rem;
                position: absolute;
            }
        }
    } 
    .top{
        position: fixed;
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background: #fff;
        font-size: 0.43rem;
        font-weight: bold;
        color: #1960ab;
        left: 0;
        top: 0;
        z-index: 10;
        border-bottom: 1px solid #f1f1f1;
        .back{
            position: absolute;
            top: 0;
            left: 0.3rem;
            font-size: 0.6rem;
            color: #333;
        }
        .right{
            position: absolute;
            top: 0;
            right: 0.3rem;
            font-size: 0.4rem;
            color: #333;
        }
    }                
</style>   